import React from "react";
import AboutUsHeroSection from "../components/AboutUs/AboutUsHeroSection";
import AboutUsSection from "../components/AboutUs/AboutUsSection";
import AboutUsMissionSection from "../components/AboutUs/AboutUsMissionSection";
import AboutUsVisionSection from "../components/AboutUs/AboutUsVisionSection";
// import AboutUsOurStory from "../components/AboutUs/AboutUsOurStory";
import AboutUsTeamSection from "../components/AboutUs/AboutUsTeamSection";
import CtaArea from "../components/CtaArea";
import AboutUsTestimonials from "../components/AboutUs/AboutUsTestimonials";

const AboutUs = () =>{
    return(
        <>
            <AboutUsHeroSection/>
            {/* <AboutUsBanner/> */}
            <AboutUsSection/>
            <AboutUsMissionSection/>
            <AboutUsVisionSection/>
            {/* <AboutUsOurStory/> */}
            <AboutUsTestimonials/>
            <AboutUsTeamSection/>
            <CtaArea/>
        </>
    )
}

export default AboutUs;